import { Component, OnInit } from '@angular/core';

interface Arquivo {
  id: number;
  nome: string;
  tipo: 'pasta' | 'arquivo';
  icone: string;
  tamanho?: string;
  dataModificacao?: Date;
  filhos?: Arquivo[];
  expandido?: boolean;
}

@Component({
  selector: 'app-documento-apoio',
  templateUrl: './documento-apoio.component.html',
  styleUrls: ['./documento-apoio.component.scss']
})
export class DocumentoApoioComponent implements OnInit {
  arquivos: Arquivo[] = [];

  constructor() {}

  ngOnInit(): void {
    this.carregarArquivos();
  }

  carregarArquivos() {
    // Mock data - substituir por chamada à API
    this.arquivos = [
      {
        id: 1,
        nome: 'Documentos de Apoio',
        tipo: 'pasta',
        icone: 'feather icon-folder',
        expandido: true,
        filhos: [
          {
            id: 2,
            nome: 'Manuais',
            tipo: 'pasta',
            icone: 'feather icon-folder',
            expandido: true,
            filhos: [
              {
                id: 3,
                nome: 'Manual de Auditoria.pdf',
                tipo: 'arquivo',
                icone: 'feather icon-file-text',
                tamanho: '2.5 MB',
                dataModificacao: new Date('2024-03-15')
              },
              {
                id: 4,
                nome: 'Manual de Qualidade.pdf',
                tipo: 'arquivo',
                icone: 'feather icon-file-text',
                tamanho: '1.8 MB',
                dataModificacao: new Date('2024-03-16')
              }
            ]
          },
          {
            id: 5,
            nome: 'Templates',
            tipo: 'pasta',
            icone: 'feather icon-folder',
            filhos: [
              {
                id: 6,
                nome: 'Template Checklist.docx',
                tipo: 'arquivo',
                icone: 'feather icon-file-text',
                tamanho: '500 KB',
                dataModificacao: new Date('2024-03-17')
              }
            ]
          }
        ]
      }
    ];
  }

  toggleExpandir(arquivo: Arquivo) {
    if (arquivo.tipo === 'pasta') {
      arquivo.expandido = !arquivo.expandido;
    }
  }

  getTamanhoFormatado(tamanho: string): string {
    return tamanho;
  }

  getDataFormatada(data: Date): string {
    return data.toLocaleDateString('pt-BR');
  }

  downloadArquivo(arquivo: Arquivo) {
    if (arquivo.tipo === 'arquivo') {
      console.log('Download do arquivo:', arquivo.nome);
      // Implementar lógica de download
    }
  }
} 